/**
 * 並び替えプルダウン
 */
import CustomPulldownBase from './script-pulldown-base.js';

export default class PulldownSort extends CustomPulldownBase {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
    for (const input of this.inputs) {
      input.addEventListener('click', this.selectItem.bind(this));
    }
  }

  /**
   * プルダウン選択時の個別実行処理
   */
  selectItem(e) {
    this.toggleOpen(e)
    this.searchParams = new URLSearchParams(location.search);
    this.searchParams.set('sort_by', e.target.value);
    this.searchParams.delete('page');
    history.replaceState(
      {},
      '',
      location.pathname + '?' + this.searchParams.toString(),
    );
    this.fetchEvent().then((res) => {});
  }
  fetchEvent() {
    this.searchParams.set('section_url', location.href);
    this.searchParams.set('sections[]', this.dataset.id);
    return new Promise((resolve) => {
      fetch(location.pathname + '?' + this.searchParams.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then((res) => {
          document.querySelector(`[data-id="${this.dataset.id}"]`).innerHTML =
            res[this.dataset.id];
        })
        .catch((error) => {
          console.error(
            'There has been a problem with your fetch operation:',
            error,
          );
        });
    });
  }
}
